import { AuthService } from './../../services/auth.service';
import { NgForm } from '@angular/forms';
import { MensajesService } from './../../services/mensajes.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { IntervinientesService } from './../../services/intervinientes.service';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { ExpedientesService } from '../../services/expedientes.service';

@Component({
  selector: 'app-interviniente',
  templateUrl: './interviniente.component.html',
  styles: [`
    .ng-invalid.ng-dirty:not(form){
      border:1px solid red;
    }
    .ng-submitted .ng-invalid:not(form){
      border:1px solid red;
    }
  `]
})
export class IntervinienteComponent implements OnInit {

  @ViewChild("mensajeInterviniente") mensajeInterviniente: ElementRef;
  @ViewChild("formulario") formulario: ElementRef;
  @ViewChild("mensajeRecuperar") mensajeRecuperar: ElementRef;
  @ViewChild("formulario2") formulario2: ElementRef;
  @ViewChild ("modalpass") modalpass:ElementRef;
  @ViewChild ("botonCerrar") botonCerrar:ElementRef;
  codigo;
  interviniente={};
  mensajesRecibidos;
  mensajesEnviados;

  ordenacion={};
  ordenacionExpedientes={};

  usuarioPass={
    INpassword:"",
    nextPass:"",
    nextPass2:""
  };

  expedientes=[];

  paginaActualRecibidos:number=1;
  paginaSiguienteRecibidos:number;
  paginaAnteriorRecibidos:number;
  totalPaginasRecibidos:number;

  paginaActualEnviados:number=1;
  paginaSiguienteEnviados:number;
  paginaAnteriorEnviados:number;
  totalPaginasEnviados:number;

  paginaActualExpedientes:number=1;
  paginaSiguienteExpedientes:number;
  paginaAnteriorExpedientes:number;
  totalPaginasExpedientes:number;


  constructor(private auth:AuthService, private router:Router, private location:Location, 
    private intervinientesService:IntervinientesService, private activatedRoute:ActivatedRoute,
    private mensajesService:MensajesService, private renderer:Renderer2, private _expedientesService:ExpedientesService) {
    
    this.mensajesEnviados=[];
    this.mensajesRecibidos=[];

    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
    });
    this.interviniente={INcif:""};
  }

  ngOnInit() {

    this.ordenacion['campo']="MEfecha";
    this.ordenacion['orden']="DESC";

    this.ordenacionExpedientes['campo']="EXfechaapertura";
    this.ordenacionExpedientes['orden']="DESC";


    this.intervinientesService.getPerfiles().subscribe();
    
    if(this.codigo!="nuevo"){
      this.cargarInterviniente();
    }
  }

  cargarInterviniente(){
    this.intervinientesService.getInterviniente(this.codigo).subscribe(resp=>{
      
      this.interviniente=resp["interviniente"];
      
      this.cargarMensajesEnviados(this.paginaActualEnviados);
      this.cargarMensajesRecibidos(this.paginaActualRecibidos);
      this.getExpedientesPorFiltro(this.paginaActualExpedientes);
    });

  
  }

  
  goBack(){
    this.location.back();
  }

  guardarInterviniente(myform: NgForm){
    this.renderer.addClass(this.formulario.nativeElement, "ng-submitted");
    
    if(myform.valid){
      if(this.codigo=="nuevo"){
        this.insertarInterviniente();
      }else{
        this.updateInterviniente();
      }
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
      this.renderer.addClass(this.mensajeInterviniente.nativeElement, "text-danger");
      this.renderer.appendChild(this.mensajeInterviniente.nativeElement,texto);
      setTimeout(() => {
        this.renderer.removeClass(this.mensajeInterviniente.nativeElement, "text-danger");
        this.renderer.removeChild(this.mensajeInterviniente.nativeElement, texto);
      }, 2000);
    }
    
  }

  insertarInterviniente(){
    
    this.intervinientesService.insertInterviniente(this.interviniente)
    .subscribe(response=>{
      let texto=this.renderer.createText(response["msg"]);
      if(response["err"]==false){
        this.renderer.addClass(this.mensajeInterviniente.nativeElement, "text-success");
        setTimeout(() => {
          this.renderer.removeClass(this.mensajeInterviniente.nativeElement, "text-success");
        }, 2000);
      }else{
        this.renderer.addClass(this.mensajeInterviniente.nativeElement, "text-danger");
        setTimeout(() => {
          this.renderer.removeClass(this.mensajeInterviniente.nativeElement, "text-danger");
        }, 2000);
      }
      
      this.renderer.appendChild(this.mensajeInterviniente.nativeElement,texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeInterviniente.nativeElement,texto);
          if(response["err"]==false){
            this.location.back();
          }
        }, 2000);
      });
      

    
  }

  updateInterviniente(){
    this.intervinientesService.updateInterviniente(this.interviniente)
    .subscribe(response=>{
      let texto=this.renderer.createText(response["msg"]);
      if(response["err"]==false){
        this.renderer.addClass(this.mensajeInterviniente.nativeElement, "text-success");
        
      }else{
        this.renderer.addClass(this.mensajeInterviniente.nativeElement, "text-danger");
      }
      this.renderer.appendChild(this.mensajeInterviniente.nativeElement,texto);
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeInterviniente.nativeElement,texto);
        
      }, 2000);
    })
  }

  cargarMensajesEnviados(pagina){
    this.mensajesService.getMensajesEnviados(this.interviniente, pagina, this.ordenacion).subscribe(resp=>{
      this.mensajesEnviados=resp["mensajes"];
      this.paginaActualEnviados=parseInt(resp["pagina"]);
      this.paginaAnteriorEnviados=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteEnviados=parseInt(resp["pag_siguiente"]);
      this.totalPaginasEnviados=parseInt(resp["total_paginas"]);
    });
  }
  
  cargarMensajesRecibidos(pagina){
    this.mensajesService.getMensajesRecibidos(this.interviniente, pagina, this.ordenacion).subscribe(resp=>{
      this.mensajesRecibidos=resp["mensajes"];
      this.paginaActualRecibidos=parseInt(resp["pagina"]);
      this.paginaAnteriorRecibidos=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteRecibidos=parseInt(resp["pag_siguiente"]);
      this.totalPaginasRecibidos=parseInt(resp["total_paginas"]);
    });
  }

  previousPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaAnteriorRecibidos);
  }

  previousPageEnviados(){
    this.cargarMensajesEnviados(this.paginaAnteriorEnviados);
  }

  nextPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaSiguienteRecibidos);
  }

  nextPageEnviados(){
    this.cargarMensajesEnviados(this.paginaSiguienteEnviados);
  }





  guardarNuevaPass(myform:NgForm){
    let texto;
    this.renderer.addClass(this.formulario2.nativeElement, "ng-submitted");
    if(myform.valid){
      if(this.usuarioPass["nextPass"]==this.usuarioPass["nextPass2"]){
        this.usuarioPass["INcodigo"]=this.interviniente["UScodigo"];
        this.intervinientesService.cambiarPass(this.usuarioPass)
        .subscribe(resp=>{
          texto=this.renderer.createText("");
          if(resp["err"]==false){
            texto=this.renderer.createText("La contraseña ha sido actualizada.");
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-success");
          }else{
            texto=this.renderer.createText(resp["msg"]);
            this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
          }
        });
      
      }else{
        this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
        texto=this.renderer.createText("La contraseña repetida no coincide con la nueva contraseña.")
      }
    }else{
      this.renderer.addClass(this.mensajeRecuperar.nativeElement, "text-danger");
      texto=this.renderer.createText("Hay errores en el formulario.");
    }

    this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
    setTimeout(() => {
      this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
      this.botonCerrar.nativeElement.click();
    }, 1000);
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    this.cargarMensajesEnviados(this.paginaActualEnviados);
    this.cargarMensajesRecibidos(this.paginaActualRecibidos);
  }

  ordenarTablaExpedientes(campo){
    if(this.ordenacionExpedientes['campo']==campo && this.ordenacionExpedientes['orden']=='DESC'){
      this.ordenacionExpedientes['orden']='ASC';
    }else{
      this.ordenacionExpedientes['campo']=campo;
      this.ordenacionExpedientes['orden']='DESC';
    }

    this.getExpedientesPorFiltro(this.paginaActualExpedientes);
  }

  getExpedientesPorFiltro(pagina){
    
    let filtro = { 
      ref :"",
      titulo:"",
      cliente:"",
      usuarioacargo:"",
      fapertura:"",
      fcierre:"",
    };

    this._expedientesService.getExpedientesDeInterviniente(this.interviniente['INcodigo'], filtro, pagina, this.ordenacionExpedientes)
      .subscribe(resp=>{
        this.expedientes=resp["expedientes"];
        this.paginaActualExpedientes=parseInt(resp["pagina"]);
        this.paginaAnteriorExpedientes=parseInt(resp["pag_anterior"]);
        this.paginaSiguienteExpedientes=parseInt(resp["pag_siguiente"]);
        this.totalPaginasExpedientes=parseInt(resp["total_paginas"]);
        
    });
  }

  nextPageExpedientes(){
    this.getExpedientesPorFiltro(this.paginaSiguienteExpedientes);
  }

  previousPageExpedientes(){
    this.getExpedientesPorFiltro(this.paginaAnteriorExpedientes);
  }
}





// WEBPACK FOOTER //
// ./src/app/components/interviniente/interviniente.component.ts